import React from 'react';

const SectionCaption = ({text}) => {
  return <span className="tcc-secction-caption">{text}</span>;
};

export default SectionCaption;
